import getLiabilitySteps from '@flows/configs/liabilityNxt/steps'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration, AnySteps } from '@flows/core/types/stepTypes'

import drone_weight from './drone_weight'
import liability_quote from './liability_quote'
import number_of_drones from './number_of_drones'

const getSteps = (params: StepConfigParams) => {
  const liabilitySteps = getLiabilitySteps(params)
  return {
    ...liabilitySteps,
    number_of_drones: number_of_drones(params),
    drone_weight: drone_weight(params),
    liability_quote: liability_quote(params, liabilitySteps.liability_quote),
    liability_drone: {
      ...liabilitySteps.liability_drone,
      skipStep: {
        condition: () => true,
        targetStepName: 'liability_quote',
      },
    } as const satisfies AnyStepConfiguration,
  } as const satisfies AnySteps
}

export default getSteps
